import _ from 'lodash';

export default angular
  .module('doxy.global.common.services.globalHelpers', [])
  .factory('globalHelpers', function () {
    return {
      includes: function (arr, elem) {
        return arr.indexOf(elem) !== -1;
      },

      pick: function (obj, params) {
        if (!obj) return {};
        return _.pick(obj, params);
      },

      find: _.find.bind(_),
    };
  }).name;
